<template>
  <qx-card title="">
    <Order ref="byDate" width="100%" />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="pageData"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
          />
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
              prop="control"
              label="操作"
              width="50"
              fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                  :tableData="scope.row"
                  :isCenter="true"
                  :btnList="[
                  {
                    permpisions: '',
                    showCondition: true,
                    name: '详情',
                    event: () => toDetail(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import {getOilAndGasConsumptionByDate} from 'api/service';
import Order from './order';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
    Order,
  },
  props: {
    vehicleType: {
      type: Number,
    },
  },
  data () {
    return {
      // 分页的数据
      pageData: [],
      // 总数据量 默认为 0
      pageTotal: 0,
      // 当前页 默认是第一页
      currentPage: 1,
      // 每页大小 默认每页10条数据
      pageSize: 10,

      chartObj: {},
      tableData: { // 表格相关数据
        loading: false,
        // count: 10,
        // page: 1,
        // total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'createDate', label: '日期'},
          {prop: 'mileageSum', label: '总里程（KM）'},
          {prop: 'driverTimeSumStr', label: '行驶时长'},
          {prop: 'fuelCostSum', label: '总油耗（L）'},
          {prop: 'avgHundredFuelAvg', label: '百公里平均油耗（L/100KM）'},
          {prop: 'idleTimeSum', label: '怠速时长'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  watch: {
    vehicleType: {
      immediate: true,
      async handler (val) {
        if (val === 2) {
          this.tableData.title.forEach((item) => {
            if (item.label.includes('百公里平均油耗')) {
              item.label = '百公里平均气耗（m³/100KM）';
            }
            if (item.label.includes('总油耗')) {
              item.label = '总气耗（m³）';
            }
          });
        } else {
          this.tableData.title.forEach((item) => {
            if (item.label.includes('百公里平均气耗')) {
              item.label = '百公里平均油耗（L/100KM）';
            }
            if (item.label.includes('总气耗')) {
              item.label = '总油耗（L）';
            }
          });
        }
      },
    },
  },
  methods: {
    getList: getOilAndGasConsumptionByDate,
    handleCurrentChange (page) { // 改变当前页
      this.currentPage = page;
      this.getData({...this.searchBoxData});
      this.pageData = this.queryByPage();
    },
    handleSizeChange (val) { // 改变每页几条
      this.pageSize = val;
      this.getData({...this.searchBoxData});
      this.pageData = this.queryByPage();
    },
    // 实现分页的方法
    queryByPage () {
      // 起始位置 = (当前页 - 1) x 每页的大小
      const start = (this.currentPage - 1) * this.pageSize;
      // 结束位置 = 当前页 x 每页的大小
      const end = this.currentPage * this.pageSize;
      return this.tableData.data.slice(start, end);
    },
    handleSubSucc (res) {
      this.pageTotal = this.tableData.data.length;
      this.pageData = this.queryByPage();
      this.getChartData(res);
    },
    toDetail (item) {
      this.$emit('jumpVehicle', item);
    },
    async getChartData (data) {
      this.chartObj = data.option;
      this.chartObj.isShowCustomData = true;
      delete this.chartObj.toolbox;
      this.$nextTick(() => {
        this.$refs.byDate.setOptions(this.chartObj);
      });
    },
  },
};
</script>

<style scoped>

</style>
